import { render, staticRenderFns } from "./MemberBetDetail.vue?vue&type=template&id=5a2900fe"
import script from "./MemberBetDetail.vue?vue&type=script&lang=js"
export * from "./MemberBetDetail.vue?vue&type=script&lang=js"
import style0 from "./MemberBetDetail.vue?vue&type=style&index=0&id=5a2900fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports